module.exports = __webpack_public_path__ + "img/ico-excel-blue.285202b6.svg";